import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { FileText, Globe, Network, TrendingUp, Plane, Users, AlertTriangle, Scale, Briefcase, Home, MapPin, Gavel } from 'lucide-react';
import { expertise } from '../data/mock';

const iconMap = {
  FileText,
  Globe,
  Network,
  TrendingUp,
  Plane,
  Users,
  AlertTriangle,
  Scale,
  Briefcase,
  Home,
  MapPin,
  Gavel
};

const Expertise = () => {
  return (
    <section id="expertise" className="py-20 bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 font-semibold text-lg mb-2">Core Areas</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            Areas of Expertise
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive tax and financial advisory services backed by decades of experience
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {expertise.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-none bg-white"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-amber-600 transition-colors duration-300">
                    <IconComponent className="w-7 h-7 text-amber-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-slate-800 group-hover:text-amber-600 transition-colors">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Expertise;